import { DICE_AUTH_CAST_CHANNEL, DICE_MESSAGING_CAST_CHANNEL } from '@dicetechnology/dice-doris';
import { LogLevels, addConfig, buildConfig } from '@dicetechnology/doris-core';
import { addHlsHandlerAsync } from '@dicetechnology/doris-handler-hls';
import { addNativeHandlerAsync } from '@dicetechnology/doris-handler-native';
import { addShakaHandlerAsync } from '@dicetechnology/doris-handler-shaka';
import {
    ChromecastLoggerLevel,
    addChromecastReceiverPluginAsync,
    getChromecastModel
} from '@dicetechnology/doris-plugin-chromecast-receiver';
import { addDirectManifestSsaiPlugin } from '@dicetechnology/doris-plugin-direct-manifest-ssai';
import { addMuxPlugin } from '@dicetechnology/doris-plugin-mux';

import pkg from '../../package.json';
import { DEFAULT_SETTINGS, EXPERIMENT } from '../constants';
import { DiceReceiverManager } from '../services';

import { loadInterceptor } from './loadInterceptor';
import { mediaStatusInterceptor } from './mediaStatusInterceptor';
import { seekInterceptor } from './seekInterceptor';

const isLoggingEnabled = () => {
    return localStorage.getItem('DORIS_DEBUG_LOGGING') === 'TRUE';
};

export const buildPlayerConfiguration = () =>
    buildConfig(
        addConfig({
            debug: {
                enabled: true
            },
            logging: {
                logLevel: isLoggingEnabled() ? LogLevels.DEBUG : LogLevels.WARN
            },
            mountToWindow: true,
            mountPluginsToWindow: true,
            sourceResolvers: [DiceReceiverManager.getInstance().getSourceResolverDefinition()],
            useHtmlTextTracks: true,
            initialBandwidthFactor: {
                enabled: EXPERIMENT === 'start-up',
                maximumDurationSeconds: 20
            }
        }),

        addHlsHandlerAsync(),
        addShakaHandlerAsync({
            experimentalSkipWidevineAndroidPatch: true
        }),
        addNativeHandlerAsync(),

        addMuxPlugin('mux', {
            // Environment key is a default only, it should be overwritten at load time.
            environmentKey: DEFAULT_SETTINGS.muxEnvironmentKey,
            playerName: 'Chromecast',
            playerVersion: pkg.version,
            deviceModel: getChromecastModel(),
            audioLanguageTrackingField: 'custom_3'
        }),
        addChromecastReceiverPluginAsync('chromecast-receiver', {
            customNamespaces: {
                [DICE_AUTH_CAST_CHANNEL]: 'JSON',
                [DICE_MESSAGING_CAST_CHANNEL]: 'JSON'
            },
            loadInterceptor,
            loggerLevel: isLoggingEnabled() ? ChromecastLoggerLevel.DEBUG : ChromecastLoggerLevel.NONE,
            mediaStatusInterceptor,
            seekInterceptor
        }),
        addDirectManifestSsaiPlugin('direct-manifest-ssai')
    );
